const GradientSvg = props => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 1216 592" {...props}>
    <g clipPath="url(#a)">
      <mask
        id="e"
        width={1216}
        height={592}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'alpha'
        }}
      >
        <rect
          width={1216}
          height={592}
          fill="url(#b)"
          rx={16}
          transform="matrix(-1 0 0 1 1216 0)"
        />
        <rect
          width={1215}
          height={591}
          x={-0.5}
          y={0.5}
          stroke="url(#c)"
          strokeOpacity={0.3}
          rx={15.5}
          transform="matrix(-1 0 0 1 1215 0)"
        />
      </mask>
      <g filter="url(#d)" mask="url(#e)">
        <rect width={1216} height={592} fill="url(#f)" rx={16} />
        <rect width={1215} height={591} x={0.5} y={0.5} rx={15.5} />
      </g>
    </g>
    <defs>
      <radialGradient
        id="b"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="rotate(149.673 515.25 139.638) scale(1233.84 1258.59)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" />
        <stop offset={0.368} stopColor="#F5D7FF" />
        <stop offset={0.513} stopColor="#FFB7FA" />
        <stop offset={0.722} stopColor="#F096FF" />
        <stop offset={1} stopColor="#AF70FF" />
      </radialGradient>
      <radialGradient
        id="f"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="matrix(0 506 -1313.4 0 608 86)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.516} />
        <stop offset={0.823} stopColor="#F096FF" />
        <stop offset={1} stopColor="#FDEEFF" />
      </radialGradient>
      <linearGradient
        id="c"
        x1={1216}
        x2={287.217}
        y1={0}
        y2={880.602}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" />
        <stop offset={1} stopColor="#fff" stopOpacity={0} />
      </linearGradient>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h1216v592H0z" />
      </clipPath>
      <filter
        id="d"
        width={1288}
        height={664}
        x={-36}
        y={-36}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImageFix" stdDeviation={6} />
        <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_2_2" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset />
        <feGaussianBlur stdDeviation={18} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0.0125 0 0 0 0 0.0125 0 0 0 0 0.0125 0 0 0 0.2 0" />
        <feBlend in2="effect1_backgroundBlur_2_2" result="effect2_dropShadow_2_2" />
        <feBlend in="SourceGraphic" in2="effect2_dropShadow_2_2" result="shape" />
      </filter>
    </defs>
  </svg>
);

export default GradientSvg;
